/**
 * A room's floor outline as the existing-conditions pass reads it: the first
 * floor's `polygonCorners` as plan points `{ x, z }`, to a tenth of a
 * millimetre. Its own module so the web can read outlines without
 * `surfaceTargets.js`, which needs Node's `crypto`. Pure.
 */
const r4 = (n) => Math.round(n * 1e4) / 1e4;
const xz = (p) => ({ x: r4(p.x), z: r4(p.z) });

function polygonOf(room) {
  const f = room.floors && room.floors[0];
  return f && Array.isArray(f.polygonCorners) ? f.polygonCorners.map(xz) : null;
}

module.exports = { r4, xz, polygonOf };
